import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { getPercentDisplay } from '@/modules/finances/lib/doughnut-chart-utils';
import { threeDigitsPrecisionHumanization, usLocalizedNumber } from '@/modules/shared/lib/humanization';
interface LegendItemProps {
  inline: boolean;
  name: string;
  code?: string;
  color: string;
  value: number;
  percentage: number;
}
function LegendItemMobile(t0) {
  const $ = _c(25);
  const {
    inline: t1,
    name,
    code,
    color,
    value,
    percentage
  } = t0;
  const inline = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== value) {
    t2 = threeDigitsPrecisionHumanization(value);
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const valueFormatted = t2;
  let t3;
  if ($[2] !== percentage) {
    t3 = getPercentDisplay(percentage);
    $[2] = percentage;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const formattedPercentage = `${t3}%`;
  const t4 = inline ? "flex-row gap-1 leading-3.75" : "flex-col gap-1 leading-4.5";
  let t5;
  if ($[4] !== t4) {
    t5 = cn("relative flex pl-3.5", t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = inline ? "top-1" : "top-2";
  let t7;
  if ($[6] !== t6) {
    t7 = cn("absolute left-0 h-2 w-2 rounded-full", t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== color) {
    t8 = {
      backgroundColor: color
    };
    $[8] = color;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <span data-slot="legend-dot" className={t7} style={t8} />;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = inline ? code ?? name : name;
  let t11;
  if ($[13] !== t10) {
    t11 = <div data-slot="legend-name" className="text-foreground text-xs font-semibold">{t10}</div>;
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== formattedPercentage || $[16] !== inline || $[17] !== value || $[18] !== valueFormatted) {
    t12 = <div data-slot="legend-line" className="flex items-center gap-1 text-xs leading-normal font-medium">{inline ? <><span data-slot="legend-value" className="text-muted-foreground font-semibold">{usLocalizedNumber(value, 2)}</span><span data-slot="legend-percentage" className="text-muted-foreground">({formattedPercentage})</span></> : <><span data-slot="legend-percentage" className="text-muted-foreground">({formattedPercentage})</span><span data-slot="legend-value" className="text-muted-foreground font-semibold">{valueFormatted.value} {valueFormatted.suffix}</span></>}</div>;
    $[15] = formattedPercentage;
    $[16] = inline;
    $[17] = value;
    $[18] = valueFormatted;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12 || $[22] !== t5 || $[23] !== t9) {
    t13 = <div data-slot="legend-item" className={t5}>{t9}{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t5;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}
export { LegendItemMobile };